import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const RefreshIcon = ({ stroke = "#2D2C44" }) => <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="search">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.3333 8.33333C18.3333 8.33333 16.6625 6.05685 15.3051 4.69854C13.9478 3.34022 12.072 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5C13.4192 17.5 16.3041 15.2119 17.2069 12.0833M18.3333 8.33333V3.33333M18.3333 8.33333H13.3333" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </g>
</SvgIcon>;

export default RefreshIcon;
